export const DEFAULT_LABOR_HOURS_SAVE_LOADING =
  'DEFAULT_LABOR_HOURS_SAVE_LOADING';
export const DEFAULT_LABOR_HOURS_FETCH_LOADING =
  'DEFAULT_LABOR_HOURS_FETCH_LOADING';
export const DEFAULT_LABOR_HOURS_SAVE_SUCCESSFUL =
  'DEFAULT_LABOR_HOURS_SAVE_SUCCESSFUL';
export const DEFAULT_LABOR_HOURS_SAVE_DEFAULT_LABOR_HOURS_ERROR =
  'DEFAULT_LABOR_HOURS_SAVE_DEFAULT_LABOR_HOURS_ERROR';
export const DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS =
  'DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS';
export const DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS_ERROR =
  'DEFAULT_LABOR_HOURS_GET_DEFAULT_LABOR_HOURS_ERROR';
export const DEFAULT_LABOR_HOURS_CLEAR_ERRORS =
  'DEFAULT_LABOR_HOURS_CLEAR_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/defaultlaborhours/state/types.js